export const Home = () => {
  return (
    <svg
      aria-hidden="true"
      role="img"
      className="iconify iconify--mdi"
      width="32"
      height="32"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M10 20v-6h4v6h5v-8h3L12 3L2 12h3v8h5Z"
      ></path>
    </svg>
  );
};
